import React from "react";
import { useRecoilValue } from "recoil";
import PropTypes from "prop-types";
import map from "lodash/map";
import { getGameTypes } from "state/gameSetupState";
import Dropdown from "components/common/Dropdown";

export default function GameTypeDropdown(props) {
    const {
		disabled = false,
	    filters = {},
	    label = "Game Type",
	    name,
	    onChange,
	    placeholder = "Select game Type",
	    required = false,
	    value,
	} = props;
	const gameTemplatesList = useRecoilValue(getGameTypes(filters));

	const options = map(gameTemplatesList, template => ({
		name: template.displayTitle,
		value: template.gameType,
	}));

    return (
        <Dropdown
            disabled={disabled}
            label={label}
            name={name}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            required={required}
            value={value}
        />
    );
}

GameTypeDropdown.propTypes = {
	disabled: PropTypes.bool,
	label: PropTypes.string,
	name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	required: PropTypes.bool,
	value: PropTypes.string,
}
